import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Archive from "./archive"


const CategoryArchive = ({
  data,
  pageContext: { nextPagePath, previousPagePath },
  location: { pathname },
}) => {
  const posts = data.posts.nodes || []
  const settings = data.settings.nodes[0]?.archiveSettings?.archiveOptions || {};
  const category = data.category || {}
  const title = category.name;

  return (
    <Layout isHomePage>
      <Seo title={title} />
      <Archive title={title} posts={posts} nextPagePath={nextPagePath} previousPagePath={previousPagePath} currentPagePath={pathname} settings={settings} />
    </Layout>
  )
}

export default CategoryArchive

export const pageQuery = graphql`
  query WordPressCategoryArchive($offset: Int!, $postsPerPage: Int!, $catId:
String!) {
  posts: allWpPost(
    sort: {date: DESC}
    limit: $postsPerPage
    skip: $offset
    filter: {categories: {nodes: {elemMatch: {id: {eq: $catId}}}}}
  ) {
    nodes {
      excerpt
      uri
      date(formatString: "MMM.DD.YYYY")
      title
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 800
                formats: [AUTO, WEBP, AVIF]
                transformOptions: {fit: COVER}
              )
            }
          }
        }
      }
    }
  }
  category: wpCategory(id: {eq: $catId}) {
    name
    description
  }
  settings: allWp {
    nodes {
      archiveSettings {
        archiveOptions {
          featuredCategories {
            heading
            buttons {
              url
              label
            }
          }
          ctas {
            heading
            content
            image {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 600
                      formats: [AUTO, WEBP, AVIF]
                      transformOptions: { fit: COVER }
                    )
                  }
                }
              }
            }
            button {
              label
              url
            }
            backgroundColor
            contentColor
            headingColor
          }
        }
      }
    }
  }
}
`
